module.exports = __webpack_public_path__ + "static/media/chevron-right-black.1c3b2f5f.svg";